export const PRODUCT_TABS_ID = 'product-tabs';

export const PRODUCT_DATA_STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const PRODUCT_DATA_GC_TIME = 10 * 60 * 1000; // 10 minutes

/** How old server-rendered product data may be before we refetch it. */
export const SSR_PRODUCT_MAX_AGE_MS = 2 * 60 * 1000; // 2 minutes

/** Ordinary disagreement between the browser's clock and the server's. */
export const CLOCK_SKEW_TOLERANCE_MS = 30 * 1000; // 30 seconds
